export default __webpack_public_path__ + "media/images/icons/feather-map-pin-d616cc2a974ecddefdbc9ed507151cfa.svg";